import DcxApiManager from './api'

const api = new DcxApiManager()

export { api }
export { default as DcxApiManager } from './api'
export { default as DcxAnalytics } from './analytics'
